// @flow
import BaseComponent from '../../base_component/base_component'

export default class DownloadDocuments extends BaseComponent {
    download() {
        $(this.component)
            .closest('.data-table-component')
            .find('input[type="checkbox"]:checked')
            .each((i: number, element: Element) => {
                let name = element.getAttribute('data-filename');
                let id = element.getAttribute('data-id');
                if (!name || !id) return;

                window.open(`/file/${name}?docRef=${id}`);
            })
    }
}
